// timer function
const timer = (ms: number | undefined) => new Promise(res => setTimeout(res, ms));

export {timer};